import React from 'react';
import {ChakraProvider} from '@chakra-ui/react';
import Routing from './navigation/Router';
import './custom.css';
import Theme from './styles/Themes';
import '@fontsource/source-serif-pro';
import {QueryClient, QueryClientProvider} from 'react-query';

const queryClient = new QueryClient({defaultOptions: {queries: {refetchOnWindowFocus: false}}});

const App = () => {
  // static displayName = App.name;

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={Theme}>
        <Routing />
      </ChakraProvider>
    </QueryClientProvider>
  );
};

export default App;
